import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import React, { useEffect } from 'react';
import { BusinessToolsHeader } from '../components/business-tools';
import { SpendByDepartment } from '../components/business-tools/SpendByDepartment';
import { SpendMap } from '../components/business-tools/SpendMap';
import { TopItems } from '../components/business-tools/TopItems';
import { TopJobs } from '../components/business-tools/TopJobs';
import PageLayout from '../components/shared/PageLayout';
import CommonProvider from '../contexts/CommonContext';
import { BusinessToolsProvider } from '../contexts/BusinessToolsProvider';
import { BusinessToolsProps } from '../models/business-tools';
import { setBusinessToolsPageAnalytics } from '../utils/business-tools/analytics';

import '../styles/business-tools.scss';

export const BusinessTools = (props: BusinessToolsProps) => {
  const { customerType, customerRole } = props;
  const crumbs = useAccountCrumbs([
    {
      label: 'Track Business Spend',
      path: '/myaccount/business-tools',
    },
  ]);

  useEffect(() => {
    setBusinessToolsPageAnalytics();
  }, []);

  return (
    <PageLayout
      crumbs={crumbs}
      pageTitle="Track Business Spend"
      customerRole={customerRole}
      customerType={customerType}
      internalRoutes={['/myaccount/business-tools']}
    >
      <CommonProvider>
        <BusinessToolsProvider>
          <div className="sui-flex business-tools sui-max-w-[1039px]">
            <div
              className="business-tools__mobilePadding"
              style={{ width: '100%', paddingBottom: 5 }}
            >
              <ErrorBoundary name="business-tools-header">
                <BusinessToolsHeader />
              </ErrorBoundary>
              <ErrorBoundary name="top-jobs">
                <TopJobs />
              </ErrorBoundary>
              <ErrorBoundary name="top-items">
                <TopItems />
              </ErrorBoundary>
              <ErrorBoundary name="spend-map">
                <SpendMap />
              </ErrorBoundary>
              <ErrorBoundary name="spend-by-department">
                <SpendByDepartment />
              </ErrorBoundary>
            </div>
          </div>
        </BusinessToolsProvider>
      </CommonProvider>
    </PageLayout>
  );
};

BusinessTools.displayName = 'Track Business Spend';
